<app-modal-header-common [title]="name" [dialogRef]="dialogRef"> </app-modal-header-common>
<div style="padding: 20px; font-size: 13px">
  <div>
    <span>Description: </span>
    <b>{{description}}</b>
  </div>
  <div>
    <span>Category: </span>
    <b>{{category}}</b>
  </div>
  <div>
    <span>Applicability: </span>
    <b>{{applicability}}</b>
  </div>
  <app-tag *ngIf="showTags" [tagsIds]="tagsList" [isReadOnly]="true"></app-tag>
  <hr class="my-2" />

  <div *ngIf="template" style="height: 60vh; overflow: scroll">
    <mat-accordion>
      <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        [expanded]="isFirst"
        *ngFor="let domain of questions; first as isFirst"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> {{domain.domain}} </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Sub-Accordion for Subdomains -->
        <div style="padding: 10px !important">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let subdomain of domain.subdomains">
              <mat-expansion-panel-header>
                <mat-panel-title> {{subdomain.sub_domain}} </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                *ngFor="let data of subdomain.questions; let i = index"
                class="q mb-2 m-2"
              >
                <span>{{i + 1}}</span>
                <h6 class="m-0"><b>{{data.requirement}}</b></h6>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div
    style="padding: 10px; display: flex; justify-content: right"
    class="gap-2"
  >
    <button
      (click)="closeDialog()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="closeModal(true)"
      style="width: auto"
    >
      Proceed
    </button>
  </div>
</div>
